import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import comtConfig, { STAR_NUM } from '../Comment/config';
import Toast from '../Toast/Toast';
import { logging } from './../../actions/log';
import ComtEditor from './Editor';
import styles from './index.module.less';
import ComtScore from './Score';
import { COMT_SCORE_LABELS } from './../Comment/config';
import classNames from 'classnames';
import ts from 'typescript';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function CommontOn(props) {
  const {
    title,
    requestInfo,
    releaseInfo,
    handleUpdate,
    commentTargetInfo,
    commentInfo,
    replyInfo,
    hasScore = true,
    scoreNum,
    placeHolder,
    classWrapper = '',
    tScore = '',
    empty,
    isScoreEmpty,
  } = props;
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  const [comtCon, setComtCon] = useState(null);
  const [labels, setLabels] = useState([]);
  const [contentInfo, setContentInfo] = useState({});
  const [mentionUsers, setMentionUsers] = useState([]);
  const [funcs, setFuncs] = useState([]); //支持的功能code列表
  // 表单提交数据
  const [score, setScore] = useState(0);
  const [scoreHash, setScoreHash] = useState({});

  const logPre = requestInfo?.type === '3' ? 'Forum_' : '';

  // 获取评论详情
  async function getComtCon() {
    try {
      const res = await comtConfig.getCommentInfo({
        type: requestInfo.type,
        tagCode: requestInfo.tagCode,
        bizIdentity: requestInfo.bizIdentity,
      });
      if (res) {
        setComtCon(res);
      }
    } catch (err) {
      //
    }
  }

  // 添加评论
  async function addComtCon(data) {
    try {
      const res = await comtConfig.addCommentCon({ ...data });
      if (res.status === 0) {
        Toast.success({ content: `提交成功，待审核通过后发布` });
        handleUpdate && handleUpdate(res.data);
        if (data.type === '3') {
          setContentInfo({
            text: '',
            imgs: [],
            appList: [],
            specialList: [],
          });
        }
      } else {
        Toast.error({ content: res.message || '提交评论出错' });
      }
      dispatch(
        logging({
          category: 'R',
          action: logPre + 'Detail_Comment_Result',
          param2: {
            version: data?.commentTargetInfo?.version,
            id: data?.bizIdentity?.replace('zt_', '')?.replace('tz_', ''),
            status: res.status ? 1 : 0,
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    } catch (err) {
      //
    }
  }

  // 添加回复
  async function addComtReply(data) {
    try {
      const res = await comtConfig.addCommentReply({ ...data });
      if (res.status === 0) {
        Toast.success({ content: `回复成功！` });
        handleUpdate && handleUpdate(res.data);
        dispatch(
          logging({
            category: 'R',
            action: logPre + 'Detail_Review_Result',
            param2: {
              commentId: data?.commentId,
              reviewId: data?.replyTargetId,
              version: data?.commentTargetInfo?.version,
              id: data?.bizIdentity?.replace('zt_', '')?.replace('tz_', ''),
              status: res.status ? 1 : 0,
              source: logInfoData.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      } else {
        Toast.error({ content: res.message || '提交回复出错' });
      }
    } catch (err) {
      //
    }
  }

  useEffect(() => {
    if (releaseInfo) {
      setComtCon(releaseInfo);
    } else {
      getComtCon();
    }
  }, [releaseInfo]);

  useEffect(() => {
    if (comtCon) {
      let { labels, commentContent, mentionUsers, funcs, forbidden } = comtCon;
      if (labels) {
        setLabels(labels);
      }
      if (mentionUsers) {
        setMentionUsers(mentionUsers);
      }
      if (funcs) {
        setFuncs(funcs);
      }
      if (commentContent && !commentInfo) {
        let { contentInfo, scoreInfo } = commentContent;

        if (scoreInfo && !score) {
          setScore(scoreInfo.score);
        }
        if (contentInfo) {
          setContentInfo(contentInfo);
        }
      } else {
        setContentInfo(null);
      }
      if (forbidden) {
        handleUpdate && handleUpdate(forbidden);
        Toast.error({ content: '您的账号已被禁言' });
      }
    }
  }, [comtCon, commentInfo]);

  useEffect(() => {
    if (contentInfo && contentInfo.labelCodes && JSON.stringify(scoreHash) === '{}') {
      let obj = {};
      contentInfo.labelCodes.map(el => {
        obj[el.angleCode] = el.starLabels.score;
      });
      setScoreHash(obj);
    }
    if (!scoreNum && !contentInfo && tScore === '') {
      setScoreHash({});
      setScore(null);
    }
  }, [contentInfo, scoreNum, tScore]);

  useEffect(() => {
    if (scoreNum) {
      setScore(scoreNum);
    }
  }, [scoreNum]);

  useEffect(() => {
    let reg = /^[0-9]+$/;
    let num = comtCon?.commentContent?.scoreInfo?.score;
    if (tScore !== null) {
      if (new RegExp(reg).test(tScore)) {
        if (num && num !== tScore) {
          if (tScore === '0') {
            setScore(num);
          } else {
            setScore(tScore);
          }
        }
        if (!num) {
          setScore(tScore);
        }
        empty();
      }
    }
  }, [tScore, comtCon]);

  const handleSubmit = useCallback(
    data => {
      if (commentInfo) {
        let submitReply = {
          optType: replyInfo ? '2' : '1',
          type: requestInfo.type,
          bizIdentity: requestInfo.bizIdentity,
          commentId: commentInfo.id,
          replyTargetId: replyInfo ? replyInfo.id : commentInfo.id,
          targetUserId: replyInfo ? replyInfo.userId : commentInfo.userId,
          contentInfo: { ...data },
        };
        addComtReply(submitReply);
      } else {
        let submitComt = {
          optType: comtCon && comtCon.commentContent ? '2' : '1',
          type: requestInfo.type,
          bizIdentity: requestInfo.bizIdentity,
          commentId: comtCon && comtCon.commentContent ? comtCon.commentContent.id : '',
          commentTargetInfo,
          contentInfo: data,
        };
        if (hasScore) {
          submitComt.score = score;
          let arr = [];
          labels &&
            labels.map(el => {
              let code = el.angleCode;
              if (scoreHash[code]) {
                arr.push({
                  angleCode: code,
                  starLabels: {
                    score: scoreHash[code],
                    code: el.starLabels[STAR_NUM[scoreHash[code]]].code,
                  },
                });
              }
            });
          submitComt.contentInfo.labelCodes = arr;
        }
        if ((submitComt?.score === 0 || !submitComt?.score) && isScoreEmpty) {
          Toast.error({ content: '请评分后再提交' });
        } else {
          addComtCon(submitComt);
        }
      }
    },
    [score, requestInfo, comtCon, scoreHash, commentInfo, replyInfo],
  );

  const holderText = useCallback(() => {
    if (replyInfo) {
      return `回复 ${replyInfo.nickName || '商店用户'}`;
    }
    if (commentInfo) {
      return `回复 ${commentInfo.nickName || '商店用户'}`;
    }
    if (placeHolder) {
      return placeHolder;
    }
    return '写下您的评论...';
  }, [commentInfo, replyInfo, placeHolder]);

  const comtable = useCallback(() => {
    if (comtCon) {
      const { commentSwitch, forbidden } = comtCon;
      if (forbidden) {
        return '您的账号已被禁言';
      }
      if (commentSwitch) {
        return '啊哦，该软件不允许评分';
      }
      return '';
    }
  }, [comtCon]);

  return (
    <div className={styles.CommentOn}>
      {!hasScore && title && <div className="comt-title">{title}</div>}
      {hasScore && (
        <div className="comt-score">
          <div className="comt-score-total">
            <div className={classNames('score-total-title', title && 'softName')}>
              {title || '为此软件评分'}
            </div>
            {!scoreNum && <div className="score-total-tip">分享您的感受</div>}
            <ComtScore
              score={score}
              onChange={num => {
                if (comtable()) {
                  Toast.error({
                    content: comtable(),
                  });
                } else {
                  setScore(num);
                }
              }}
              scoreLabels={COMT_SCORE_LABELS}
              size="lg"
            />
          </div>
          {/* {(tScore !== '' || (tScore === '' && score > 0)) && */}
          {(tScore !== null || (hasScore && score > 0) || !hasScore) &&
            labels.length > 0 &&
            !comtable() &&
            funcs.indexOf('2') > 0 && (
              <div className="comt-score-more" style={{ width: scoreNum && '434px' }}>
                <div className="score-more-title">
                  <i className="iconfont icon-mine_edit" />
                  更多评价角度（非必填）
                </div>
                <div className="score-more-con">
                  {labels.map(el => {
                    return (
                      <div className="score-more-item" key={el.angleCode}>
                        <span className="score-more-item-label">{el.angleName}</span>
                        <ComtScore
                          score={scoreHash[el.angleCode]}
                          onChange={num => {
                            let obj = scoreHash;
                            scoreHash[el.angleCode] = num;
                            setScoreHash({ ...obj });
                            setTimeout(() => {
                              setScoreHash(obj);
                            }, 100);
                            dispatch(
                              logging({
                                category: 'C',
                                action: logPre + 'Comment_Grade',
                                param2: {
                                  grade: num,
                                  tagid: el.angleCode,
                                  source: logInfoData.source,
                                  source_p: logInfoData.source_p,
                                  source_pp: logInfoData.source_pp,
                                },
                              }),
                            );
                          }}
                          starLabels={el.starLabels}
                          size="sm"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
        </div>
      )}
      {/* {((hasScore && score > 0) || !hasScore) && !comtable() && ( */}
      {(tScore !== null || (hasScore && score > 0) || !hasScore) && !comtable() && (
        <ComtEditor
          onSubmit={data => {
            if (data) {
              handleSubmit(data);
            } else {
              setScore(null);
              setContentInfo({});
              handleUpdate && handleUpdate(null);
              empty();
            }
          }}
          commentContent={contentInfo}
          mentionUsers={mentionUsers}
          classWrapper={classWrapper}
          hasScore={hasScore}
          placeHolder={holderText()}
          requestInfo={requestInfo}
          score={score}
          commentInfo={commentInfo}
          commentTargetInfo={commentTargetInfo}
          replyInfo={replyInfo}
        />
      )}
    </div>
  );
}

export default memo(CommontOn);
